import React from "react";

import {Navbar, NavItem, NavLink, Nav} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import { logOut } from "../actions/loginAction";
import { useHistory } from "react-router-dom";
import {registeredLogout} from "../actions/registeredUserAction";

const Header = ({ logoutHandler }) => {

  // Read the logo from the environment variable, and trim any whitespace.
  // If the environment variable is not set, default to an empty string.
  const logo = (process.env.REACT_APP_PROPERTY_LOGO || "").trim();

  return (
    <>
      <Navbar className="w-100 gcotg-user-navbar">
        <Navbar.Brand>
          {logo && <img
            src={process.env.REACT_APP_PROPERTY_LOGO}
            className="d-inline-block align-middle navbar-logo"
            alt="Main application logo"
            />
          }
        </Navbar.Brand>
        <Navbar.Collapse className="justify-content-end">
          <Nav variant="underline">
            <NavItem>
              <NavLink onClick={logoutHandler} className="gcotg-navbar-link">
                Sign Out
              </NavLink>
            </NavItem>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </>
  );
};

export default Header;
